import { createAction } from '@reduxjs/toolkit';
export const SET_GOOGLE_SEARCHED_PLACE = 'SET_GOOGLE_SEARCHED_PLACE';
export const setGoogleSearchedPlace = createAction(SET_GOOGLE_SEARCHED_PLACE);
